import { genId } from '@hyphen-db-studio/schema-core';
import type {
  ArchitectureDiagram,
  ArchitectureEdge,
  ArchitectureNode,
  ArchitectureProject,
  EdgeDirection,
  NodeCategory,
  NodeMode,
} from './types';

export function createEmptyDiagram(): ArchitectureDiagram {
  return { nodes: [], edges: [] };
}

export function createArchitectureNode(kind: string, category: NodeCategory, label: string, mode?: NodeMode): ArchitectureNode {
  return { id: genId('node'), kind, category, label, mode };
}

export function createArchitectureEdge(
  fromNodeId: string,
  toNodeId: string,
  direction: EdgeDirection = 'forward',
  fromHandle?: string | null,
  toHandle?: string | null,
): ArchitectureEdge {
  return { id: genId('edge'), fromNodeId, toNodeId, fromHandle, toHandle, direction, animated: true };
}

export function createArchitectureProject(name: string): ArchitectureProject {
  const now = new Date().toISOString();
  return {
    id: genId('arch'),
    name,
    diagram: createEmptyDiagram(),
    createdAt: now,
    updatedAt: now,
  };
}

export function diagramStats(diagram: ArchitectureDiagram) {
  return {
    nodeCount: diagram.nodes.length,
    edgeCount: diagram.edges.length,
  };
}
